import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useState } from 'react';

const ParentModal = ({ id, onClose }) => {
	const API_URL = import.meta.env.VITE_API_URL;
	const queryClient = useQueryClient();

	const createMutation = useMutation({

	});

	const editMutation = useMutation({

	});

	const handleParentCreate = (index) => {
		createMutation.mutate(index);
		alert("부모/보호자가 추가되었습니다.");
	};

	const handleParentEdit = (index) => {
		if(!confirm("정말로 변경하시겠습니까?")) return;
		editMutation.mutate(index);
	};

	const handleParentChange = (index, field, value) => {

	};

	return (
		<div className="fixed inset-0 bg-black/70 z-[1000] flex items-center justify-center p-5 ">
			<div className="p-5 border rounded-xl bg-white space-y-2 shadow-sm">
				<input
					type="text"
					placeholder="이름을 입력해주세요."
					value={parent.name}
					onChange={(e) => handleParentChange(index, 'name', e.target.value)}
					className="w-full px-4 py-3 rounded-lg border text-sm"
				/>
				<input
					type="text"
					placeholder="이메일을 입력해주세요."
					value={parent.email}
					onChange={(e) => handleParentChange(index, 'email', e.target.value)}
					className="w-full px-4 py-3 rounded-lg border text-sm"
				/>
				<input
					type="text"
					placeholder="연락처를 입력해주세요."
					value={parent.phone}
					onChange={(e) => handleParentChange(index, 'phone', e.target.value)}
					className="w-full px-4 py-3 rounded-lg border text-sm"
				/>
				<button
					type="button"
					onClick={() => handleParentComplete(index)}
					disabled={!parent.name || !parent.email || !parent.phone}
					className={`w-full px-4 py-3 rounded-lg text-sm font-semibold transition whitespace-nowrap mt-2
		                ${parent.name && parent.email && parent.phone
		                	? "bg-purple-600 text-white hover:bg-purple-700"
		                	: "bg-gray-200 text-gray-400 cursor-not-allowed"}
		                	`}
		                >
		            입력 완료
		        </button>
	        </div>
	    </div>
	);
}

export default ParentModal;